module.exports = __webpack_public_path__ + "img/logo-black-th.a14314c7.svg";